import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { mq, mqMax } from '../../styles/mixins';
import {
  Header2,
  ParagraphS,
} from '../../components/core/Typography/Typography';

type WrapperTypes = {
  height?: number;
};

export const Wrapper = styled.div<WrapperTypes>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 40;
  width: 100%;
  max-width: 60.625rem;
  margin: 0 auto;
  padding: 2rem 1.5625rem;
  background: ${({ theme }) => theme.colors.core_white};
  box-shadow: 0.5rem 0.5rem 1.5rem rgba(23, 0, 89, 0.29);
  border-radius: 0.5rem;

  ${({ height }) =>
    height &&
    css`
      margin-top: ${-height}px;
    `};

  ${mqMax.large(css`
    max-width: 94%;
  `)};

  ${mq.large(css`
    padding: 3rem 9.375rem;
  `)};
`;

export const ButtonWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h2`
  ${Header2};
  color: ${({ theme }) => theme.colors.core_black};
  margin: 0 0 1rem 0;
  text-align: center;

  ${mq.xLarge(css`
    font-size: 2.5rem;
    line-height: 3.5rem;
  `)};
`;

export const Description = styled.p`
  ${ParagraphS};
  letter-spacing: 0.0125rem;
  text-align: center;
  margin: 0 0 1rem 0;
`;
